function initAccordionSearchBlockInputs() {
  document.querySelectorAll('.accordion-search-block').forEach((accordionSearchBlock) => {
    const accordionBlock = getNextAccordionBlock(accordionSearchBlock);
    if (accordionBlock === null) {
      return;
    }
    const searchInput = accordionSearchBlock.querySelector('.accordion-search-block__input');
    let itemPaginationSize = null;
    let paginationButton = null;
    if ('itemPaginationSize' in accordionBlock.dataset) {
      itemPaginationSize = parseInt(accordionBlock.dataset.itemPaginationSize);
      paginationButton = accordionBlock.querySelector('.accordion-block__button--pagination');
    }
    const items = accordionBlock.querySelectorAll('.accordion-block__item');

    const searchResultsTitle = accordionSearchBlock.dataset.searchResultsTitle;
    const searchResultsTextHTML = accordionSearchBlock.querySelector('.accordion-search-block__search-results-text').innerHTML;
    const searchResultsEmptyTextHTML = accordionSearchBlock.querySelector('.accordion-search-block__search-results-empty-text').innerHTML;

    const title = accordionBlock.querySelector('.accordion-block__title');
    const text = accordionBlock.querySelector('.accordion-block__text');
//accordion-block__item--open

    function sortItemDataByTermCountReverse(a, b) {
      if (a.termMatchCount < b.termMatchCount) {
        return 1;
      }
      if (a.termMatchCount > b.termMatchCount) {
        return -1;
      }
      if (a.title.length < b.title.length) {
        return -1
      }
      return 1;
    }

    function sortItemDataByIndex(a, b) {
      if (a.index < b.index) {
        return -1;
      }
      if (a.index > b.index) {
        return 1;
      }
      return 0;
    }

    function handleSearch() {
      const value = searchInput.value.trim();
      const sortedItemData = [];

      if (value.length === 0) {
        items.forEach((item) => {
          sortedItemData.push({
            title: item.querySelector('.accordion-block__item-head-title').innerHTML,
            text: item.querySelector('.accordion-block__item-text').innerHTML,
            termMatchCount: 1,
            index: parseInt(item.dataset.index)
          });
          sortedItemData.sort(sortItemDataByIndex);
        });
      } else {
        const terms = value.toLowerCase().split(' ');
        const termCountRegExps = {};

        // Create regular expressions for counting the term occurences
        terms.forEach((term) => {
          termCountRegExps[term] = new RegExp(term, 'gi');
        });

        // Create the sorted item data based on term match count
        items.forEach((item) => {
          const itemTitle = item.querySelector('.accordion-block__item-head-title').innerHTML;
          let termMatchCount = 0;
          terms.forEach((term) => {
            termMatchCount += (itemTitle.match(termCountRegExps[term]) || []).length;
          });
          sortedItemData.push({
            title: itemTitle,
            text: item.querySelector('.accordion-block__item-text').innerHTML,
            termMatchCount: termMatchCount,
            index: parseInt(item.dataset.index)
          });
        });
        sortedItemData.sort(sortItemDataByTermCountReverse);
      }

      // Handle the items
      let matchCount = 0;
      items.forEach((item, index) => {
        item.querySelector('.accordion-block__item-head-title').innerHTML = sortedItemData[index].title;
        const itemText = item.querySelector('.accordion-block__item-text');
        itemText.innerHTML = sortedItemData[index].text;
        item.dataset.index = sortedItemData[index].index;
        itemText.style.height = '0';
        item.classList.remove('accordion-block__item--open');
        if (sortedItemData[index].termMatchCount > 0) {
          matchCount += 1;
          item.classList.remove('accordion-block__item--search-hidden');
          if (itemPaginationSize !== null) {
            if (matchCount <= itemPaginationSize) {
              item.classList.remove('accordion-block__item--pagination-hidden');
            } else {
              item.classList.add('accordion-block__item--pagination-hidden');
            }
          }
        } else {
          item.classList.add('accordion-block__item--search-hidden');
        }
      });

      // Handle the title and text
      if (value.length === 0) {
        title.innerText = title.dataset.title;
        text.classList.add('accordion-block__text--hidden');
      } else {
        title.innerText = searchResultsTitle.replaceAll('{terms}', value);
        if (matchCount === 0) {
          text.innerHTML = searchResultsEmptyTextHTML;
          text.classList.add('accordion-block__text--empty');
        } else {
          text.innerHTML = searchResultsTextHTML;
          text.classList.remove('accordion-block__text--empty');
        }
        text.classList.remove('accordion-block__text--hidden');
      }

      // Handle the pagination button
      if (itemPaginationSize !== null) {
        if (matchCount > itemPaginationSize) {
          paginationButton.classList.remove('accordion-block__button--hidden');
        } else {
          paginationButton.classList.add('accordion-block__button--hidden');
        }
      }
    }

    searchInput.addEventListener('input', () => {
      handleSearch();
    });

    if (window.location.hash.length > 0) {
      let loadedTerms = window.location.hash.replace(/^#/, '');
      loadedTerms = loadedTerms.replaceAll('-', ' ');
      loadedTerms = loadedTerms.charAt(0).toUpperCase() + loadedTerms.slice(1);
      searchInput.value = loadedTerms;
      const inputEvent = new Event('input', {
        bubbles: true,
        cancelable: true
      });
      searchInput.dispatchEvent(inputEvent);
    }
    const accordionDeepLinks = document.querySelectorAll('[href^="' + window.location.pathname + '#"]');
    accordionDeepLinks.forEach((accordionDeepLink) => {
      accordionDeepLink.addEventListener('click', (event) => {
        event.preventDefault();
        let loadedTerms = accordionDeepLink.getAttribute('href').split('#')[1];
        loadedTerms = loadedTerms.replaceAll('-', ' ');
        loadedTerms = loadedTerms.charAt(0).toUpperCase() + loadedTerms.slice(1);
        searchInput.value = loadedTerms;
        const inputEvent = new Event('input', {
          bubbles: true,
          cancelable: true
        });
        searchInput.dispatchEvent(inputEvent);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  });
}

function getNextAccordionBlock(accordionSearchBlock) {
  let nextElementSibling = accordionSearchBlock.nextElementSibling;
  while (nextElementSibling !== null) {
    if (nextElementSibling.classList.contains('accordion-block')) {
      return nextElementSibling;
    }
    nextElementSibling = nextElementSibling.nextElementSibling;
  }
  return null;
}


function initAccordionSearchBlocks() {
  initAccordionSearchBlockInputs();
}


if (document.readyState !== 'loading') {
  initAccordionSearchBlocks();
} else {
  window.addEventListener('DOMContentLoaded', initAccordionSearchBlocks);
}
